
import { HttpResponse, defaultHttpResponse } from "../auth/AuthInterface";
import { PaginacionProps } from "../global/PaginacionInterface";

// Definición de defaults

export const defaultDetalleListaAcuerdosResponse: DetalleListaAcuerdosResponse = {
    ...defaultHttpResponse,
    idListaAcuerdo:         0,
    idEstatus:              0,
    asignadoMismoUsuario:   false,
    usuarioAsignado:        '',
    acuerdos:               [],
    documento:              '',
};

export const defaultBuscarListaAcuerdosResponse: BuscarListaAcuerdosResponse = {
    recordsCount:           0,
    currentPageIndex:       0,
    pageCount:              0,
    records:                [],
};

export const defaultNuevaListaAcuerdos: NuevaListaAcuerdosResponse = {
    ...defaultHttpResponse,
    idListaAcuerdo:         '',
};

export const defaultGenerarDocumentoListaAcuerdos: GenerarDocumentoListaAcuerdosResponse = {
    ...defaultHttpResponse,
    documento:              '',
};

// Creación de interfaces

export interface NuevaListaAcuerdosResponse extends HttpResponse {
    idListaAcuerdo:         string;
}

export interface AcuerdoProps {
    idAcuerdo:              number;
    idTipoAcuerdo:          number;
    tipoAcuerdo:            string;
    idSubTipoAcuerdo:       number;
    subTipoAcuerdo:         string;
    referencia:             string;
    noReferencia:           string;
    tipoJuicio:             string;
    tipoAudiencia:          string;
    tipoAmparo:             string;
    actores:                string[];
    demandados:             string[];
    fechaAcuerdo?:          Date;
    esIrregular:            boolean;
    idTipoReservado:        number;
    tipoReservado:          string;
    reservado:              boolean;
    acuerdo:                string;
    selected:               boolean;
}

export interface DetalleListaAcuerdosResponse extends HttpResponse {
    idListaAcuerdo:         number;
    documento:              string;
    idEstatus:              number;
    usuarioAsignado:        string;
    asignadoMismoUsuario:   boolean;
    acuerdos:               AcuerdoProps[];
    fecha?:                 Date;
}

export interface GenerarListaAcuerdosParams {
    idListaAcuerdos:        string;
    acuerdos:               AcuerdoProps[];
}

export interface GenerarDocumentoListaAcuerdosResponse extends HttpResponse {
    documento:              string;
}

export interface BuscarListaAcuerdosParams extends PaginacionProps {
    fechaInicio:            string;
    fechaFin:               string;
}

export interface BuscarListaAcuerdosResponse {
    currentPageIndex:       number;
    pageCount:              number;
    recordsCount:           number;
    records:                ListaAcuerdosProps[];
}

export interface ListaAcuerdosProps {
    idListaAcuerdos:        number;
    usuarioGenero:          string;
    documento:              string;
    acuerdos:               AcuerdoProps[];
    fechaGeneracion?:       Date;
}
